/**
 * Create the error  tracking object
 */

import {
    TRACKING_WEBCHAT_ERROR_LOCATION,
    TRACKING_WEBCHAT_ERROR_TYPE,
} from 'Container/Tracking/constants';
import {TrackingDataError} from 'Container/Tracking/types';

/**
 * Create the page view tracking object
 * @param {object} trackingData - Tracking Data
 */
export const createTrackingError = (trackingData: TrackingDataError) => {

    const trackingPayload = {
        type: TRACKING_WEBCHAT_ERROR_TYPE,
        code: trackingData.errorCode,
        message: trackingData.errorMessage,
        location: TRACKING_WEBCHAT_ERROR_LOCATION,
    };

    return trackingPayload;
};
